import { jsx as _jsx } from "react/jsx-runtime";
import { TableActionButton, TableCardHeader, TableCardTitle, TableNote, TableCell, TableDropdownList, TableGroup, TableHead, TableHeadRow, TableInfo, TableLoader, TableNoData, TablePagination, TableRow, usePageInfo, usePagination, } from './components';
import { StyledTable, TableScrollableWrapper, TableWrapper } from './styled';
const Component = ({ maxHeight, ...props }) => (_jsx(TableScrollableWrapper, { "$maxHeight": maxHeight, children: _jsx(StyledTable, { ...props }) }));
export const TableLegacy = Object.assign(Component, {
    ActionButton: TableActionButton,
    CardHeader: TableCardHeader,
    CardTitle: TableCardTitle,
    Note: TableNote,
    Cell: TableCell,
    DropdownList: TableDropdownList,
    Group: TableGroup,
    Head: TableHead,
    HeadRow: TableHeadRow,
    Info: TableInfo,
    Loader: TableLoader,
    NoData: TableNoData,
    Pagination: TablePagination,
    Row: TableRow,
    Wrapper: TableWrapper,
    usePageInfo,
    usePagination,
});
